const PATH_ENTRYPOINTS = {
    devadmin: "/devadmin",
    assessments: "/assessments",
    "writing-coach": "/writing-coach",
};

function matchesPathPrefix({
    pathPrefix,
    pathname,
}: {
    pathPrefix: string;
    pathname: string;
}) {
    return pathname === pathPrefix || pathname.startsWith(pathPrefix + "/");
}

export function shouldReload(entrypoint: string, pathname: string) {
    // If we're attempting to render a page that doesn't exist inside our
    // entrypoint, then we need to reload the page instead of rendering
    // to force the user to the correct entrypoint.
    if (PATH_ENTRYPOINTS[entrypoint]) {
        return !matchesPathPrefix({
            pathPrefix: PATH_ENTRYPOINTS[entrypoint],
            pathname,
        });
    }

    return Object.values(PATH_ENTRYPOINTS).some((pathPrefix) =>
        matchesPathPrefix({pathPrefix, pathname}),
    );
}

export const exportedForTesting = {PATH_ENTRYPOINTS};
